<ng-template #contextualLearningTemplate>
  <td-wb-min-height-panel>
    <td-wb-modal-header [iconId]="modalIcon">
      <td-wb-modal-header-title [modalTitle]="'tdWb.tradingLearn.modal.' + modalTitle" />
      <td-wb-modal-header-buttons>
        <td-wb-modal-close-button />
      </td-wb-modal-header-buttons>
    </td-wb-modal-header>
    <td-wb-toolbar [modal]="true">
      <td-wb-toolbar-item-print />
      <td-wb-toolbar-item-help [articleId]="modalArticleId" />
    </td-wb-toolbar>
    @if (showSubHeader) {
      <td-wb-modal-sub-header class="td-wb-trading-learn-modal__header">
        <span translate="tdWb.tradingLearn.modal.HEADER"></span>
        <td-wb-modal-header-buttons>
          <a class="td-wb-trading-learn-modal__back"
             tabindex="0"
             role="button"
             (keydown.enter)="closeModal()"
             (click)="closeModal()">
            <td-wb-icon iconId="caret-left--small" />
            <span [translate]="tabId ? getBackLinkForOrigin() : 'tdWb.tradingLearn.modal.BACK'"></span>
          </a>
        </td-wb-modal-header-buttons>
      </td-wb-modal-sub-header>
    }
    <td-wb-modal-panel [left]="false"
                       [right]="false"
                       [bottom]="true">
      <div class="td-wb-trading-learn-modal__container">
        <td-wb-learn-lesson-content [loadingIndicator]="loadingIndicator"
                                    [id]="contextualLesson?.uniqueKey" />
        @if (relatedLessons?.length > 0) {
          <td-wb-trading-learn-related-lessons
            [contextualLesson]="contextualLesson"
            [relatedLessons]="relatedLessons"
            (lessonSelected)="selectLesson($event)" />
        }
        @if (!loadingIndicator) {
          <div class="td-wb-trading-learn-modal__buttons">
            <button [id]="'td-wb-trading-learn-modal-back-to-' + tabId"
                    class="td-wb-trading-learn-modal__button"
                    tdWbButton
                    tdWbButtonType="secondary"
                    (click)="closeModal()">
              <span class="td-wb-trading-learn-modal__like-label--text"
                    [translate]="tabId ? getBackButtonForOrigin() : 'tdWb.tradingLearn.modal.BACK'">
              </span>
            </button>
            <button id="td-wb-trading-learn-modal-go-to-learning"
                    class="td-wb-trading-learn-modal__button"
                    tdWbButton
                    tdWbButtonType="secondary"
                    tdWbHref="page.learn.welcome"
                    (click)="closeModal()">
              <span class="td-wb-trading-learn-modal__like-label--text"
                    translate="tdWb.tradingLearn.modal.LEARNING_CENTER">
              </span>
            </button>
          </div>
        }
      </div>
    </td-wb-modal-panel>
  </td-wb-min-height-panel>
</ng-template>
